/*@ngInject*/
const UIDataItemsGroupDragManagerDirective = function ($rootScope, configurationConstant, dataSetEditorModel) {

    var linkFunction = function ($scope, $elm, $attr) {

        var element = $($elm),
            dataSetName = $scope.dataItemsGroup.dataSetName,
            isTopDropAttempt,
            isBottomDropAttempt;

        function onDragStart(event) {
            var isDraggingDataItemsGroup = _.includes(event.target.classList, 'dataItemsGroup'),
                dataTransfer,
                dragDropConfiguration;

            if (isDraggingDataItemsGroup) {
                if ($scope.dataItemsGroup.mouseDown) {
                    dataTransfer = event.originalEvent.dataTransfer;
                    dragDropConfiguration = {
                        dragDataItemsGroupId: $scope.dataItemsGroup.id
                    };

                    dataSetEditorModel.setDraggingDataItemsGroup(dataSetName, true);

                    element.addClass('draggingDataItemsGroup');
                    if (!$scope.dataItemsGroup.selected) {
                        $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_DRAG_DROP_FROM_UNSELECTED_GROUP, {
                            dataItemsGroupId: $scope.dataItemsGroup.id
                        });
                    }

                    // Disable pointer events on all data items groups in the UI to prevent issues
                    $('.dataItemsGroupInnerContainer').each(function (index, selectedItem) {
                        $(selectedItem).css('pointer-events', 'none');
                    });

                    dataTransfer.setData('text', JSON.stringify(dragDropConfiguration));
                    dataTransfer.effectAllowed = 'move';
                } else {
                    event.preventDefault();
                }
            }
        }

        function onDragOver(event) {
            var dataTransfer = event.originalEvent.dataTransfer,
                currentDropTarget = $(event.currentTarget),
                isElementBeingDragged = currentDropTarget.hasClass('draggingDataItemsGroup'),
                isDraggingDataItemsGroup = dataSetEditorModel.isDraggingDataItemsGroup(dataSetName),
                offsetY,
                halfheight;

            if (!isElementBeingDragged && isDraggingDataItemsGroup) {
                offsetY = event.offsetY;
                halfheight = currentDropTarget.height() / 2;
                isTopDropAttempt = offsetY < halfheight;
                isBottomDropAttempt = offsetY >= halfheight;

                currentDropTarget.removeClass('dragOverTopDataItemsGroup');
                currentDropTarget.removeClass('dragOverBottomDataItemsGroup');

                if (isTopDropAttempt) {
                    currentDropTarget.addClass('dragOverTopDataItemsGroup');
                } else if (isBottomDropAttempt) {
                    currentDropTarget.addClass('dragOverBottomDataItemsGroup');
                }

                dataTransfer.dropEffect = 'move';
                event.preventDefault();
            }
        }

        function onDragLeave(event) {
            var currentDropTarget = $(event.currentTarget);

            currentDropTarget.removeClass('dragOverTopDataItemsGroup');
            currentDropTarget.removeClass('dragOverBottomDataItemsGroup');
        }

        function onDrop(event) {
            var dataTransfer = event.originalEvent.dataTransfer,
                dragDropConfiguration = JSON.parse(dataTransfer.getData('text')),
                currentDropTarget = $(event.currentTarget),
                isDraggingDataItemsGroup = dataSetEditorModel.isDraggingDataItemsGroup(dataSetName);

            if (isDraggingDataItemsGroup) {
                handleDropOperation(currentDropTarget, dragDropConfiguration);

                event.preventDefault();
                return false;
            }
        }

        function handleDropOperation(currentDropTarget, dragDropConfiguration) {
            var takeAction = isTopDropAttempt || isBottomDropAttempt;

            element.removeClass('draggingDataItemsGroup');
            currentDropTarget.removeClass('dragOverTopDataItemsGroup');
            currentDropTarget.removeClass('dragOverBottomDataItemsGroup');

            if (takeAction) {
                dragDropConfiguration.dropDataItemsGroupId = $scope.dataItemsGroup.id;

                if (isTopDropAttempt) {
                    dragDropConfiguration.type = configurationConstant.dataSet.INSERT_BEFORE;
                } else if (isBottomDropAttempt) {
                    dragDropConfiguration.type = configurationConstant.dataSet.INSERT_AFTER;
                }

                $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_DRAG_DROP, dragDropConfiguration);
            }
        }

        function onDragEnd() {
            element.removeClass('draggingDataItemsGroup');

            $('.dataItemsGroupInnerContainer').each(function (index, selectedItem) {
                $(selectedItem).css('pointer-events', 'auto');
            });

            dataSetEditorModel.setDraggingDataItemsGroup(dataSetName, false);
        }

        element.on('dragstart', onDragStart);
        element.on('dragover', onDragOver);
        element.on('dragleave', onDragLeave);
        element.on('drop', onDrop);
        element.on('dragend', onDragEnd);

        $scope.$on('$destroy', function () {
            element.off('dragstart', onDragStart);
            element.off('dragover', onDragOver);
            element.off('dragleave', onDragLeave);
            element.off('drop', onDrop);
            element.off('dragend', onDragEnd);
        });
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umCore')
    .directive('uiDataItemsGroupDragManager', UIDataItemsGroupDragManagerDirective);
